
import index from "../components/index.vue"
import thm_about from "../components/thm/about.vue";
import thm_index from "../components/thm/index.vue"
import thm_fy from "../components/thm/fy.vue"
import thm_pic from "../components/thm/pic.vue"
import article from "../components/thm/article.vue"
import team from "../components/thm/team.vue";
import doctor from "../components/thm/doctor.vue";
import login from "../components/login/index.vue"
import reg from "../components/login/reg.vue"
import forget from "../components/login/forget.vue"

import user from "../components/user/zz.vue"
import user_index from "../components/user/index.vue"
import user_info from "../components/user/info.vue"
import user_report from "../components/user/report.vue"
import user_safe from "../components/user/safe.vue"
import user_myorder from "../components/user/myorder.vue"
import user_mybook from "../components/user/mybook.vue"
import user_book from "../components/user/book.vue";
import user_person from "../components/user/person.vue";
import user_team from "../components/user/team.vue";
import user_reportd from "../components/user/report_detail.vue";
import user_car from "../components/user/mycar.vue";
import family from "../components/user/family.vue";
import like from "../components/user/like.vue";
import buy from "../components/user/buy.vue";
import user_card from "../components/user/card.vue"


import mall from "../components/mall/mall.vue";
import mall_detail from "../components/mall/detail.vue";
import about from "../components/other/about.vue";
import hm from "../components/other/hm.vue";
import pd from "../components/other/pd.vue";
import page404 from "../components/other/page404.vue";
import test from "../components/other/test.vue";


const routes = [
  {path: '*', component: page404},
  {path: '/', component: index },
  {path:'/thm/index/:id',component:thm_index,alias:"/hs/index/:id"},
  //{path:'/hs/index/:id',component:thm_index},
  {path:'/thm/about',component:thm_about},
  {path:'/thm/acticle/nid/:nid/b/:b',component:article},
  {path:'/hs/acticle/nid/:nid/b/:b',component:article},
  {path:'/thm/pic/n/:nid/fid/:fid/title/:title',component:thm_pic},
  {path:'/thm/fy/n/:id',component:thm_fy,alias:'/thm/img/n/:id'},
  //{path:'/thm/img/n/:id',component:thm_fy},
  {path:'/thm/team/n/:id',component:team},
  {path:"/thm/doctor/d/:id",component:doctor},
  {path:'/user',component:user,children:[
      {path:'index',component:user_index},
      {path:'info',component:user_info},
      {path:"report",component:user_report},
      {path:"report/detail/:id",component:user_reportd},
      {path:"safe",component:user_safe},
      {path:"order/:id",component:user_myorder},
      {path:"mybook",component:user_mybook},
      {path:"book",component:user_book},
      {path:"person/:id",component:user_person},
      {path:"team",component:user_person},
      {path:'mycar',component:user_car},
      {path:"family",component:family},
      {path:"like",component:like},
      {path:"buy/:id",component:buy},
      {path:"card",component:user_card}
  ]},
  {path:"/login",component:login},
  {path:"/reg",component:reg},
  {path:"/forget",component:forget},
  {path:"/about",component:about,alias:"/about/index"},
  {path:'/pd',component:pd},
  {path:"/hm",component:hm},
  {path:"/mall",component:mall},
  {path:"/mall/detail/code/:id",component:mall_detail},
  {path:"/mall/detail/code/:id/wjtoken/:wjtoken",component:mall_detail},
  {path:"/mall/detail/ucode/:gucode",component:mall_detail},
  {path:"/test",component:test},
 
];

export default routes



// WEBPACK FOOTER //
// ./src/js/routes.js